import { useAddToCartHandle } from '@screens/Cart/hooks/useAddToCartHandle';
import { CATEGORY_URL, SUB_CATEGORY_URL } from '@screens/Product/model/config/path';
import {
  ID_ARTICLE_ATTRIBUTE,
  ID_DEPTH_ATTRIBUTE,
  ID_HEIGHT_ATTRIBUTE,
  ID_PRODUCT_IMAGE_ATTRIBUTE,
  ID_REMAINDER_ATTRIBUTE,
  ID_SEO_NAME_ATTRIBUTE,
  ID_SUBCATEGORY_ATTRIBUTE,
  ID_TYPE_PRODUCT_ATTRIBUTE,
  ID_WIDTH_ATTRIBUTE
} from '@shared/constants/keys';
import { useAppSelector } from '@shared/hooks/redux';
import { Button } from '@shared/ui/Button';
import { getViewPort } from '@shared/ui/ScreenSizeTracking';

export const CartButton = () => {
  const viewPort = useAppSelector(getViewPort);

  const name = useAppSelector((state) => state.product.data.name);
  const price = useAppSelector((state) => state.product.data.retailPrice);
  const props = useAppSelector((state) => state.product.data.props);
  const id = useAppSelector((state) => state.product.data.id);
  const translitName = useAppSelector((state) => state.product.data.translitName);

  const categoryName = props[ID_TYPE_PRODUCT_ATTRIBUTE]?.values?.[0]?.value;
  const subCategoryName = props[ID_SUBCATEGORY_ATTRIBUTE]?.values?.[0]?.value;
  const remainder = props[ID_REMAINDER_ATTRIBUTE]?.values?.[0]?.value;
  const seoName = props[ID_SEO_NAME_ATTRIBUTE]?.values?.[0]?.value;

  const category = categoryName ? CATEGORY_URL[categoryName] : '';
  const subCategory = subCategoryName ? SUB_CATEGORY_URL[subCategoryName] : '';

  const images = useAppSelector((state) => state.product.data.props[ID_PRODUCT_IMAGE_ATTRIBUTE]?.values);

  const { productInCart, handleClickAddToCart } = useAddToCartHandle({
    id,
    name,
    seoName,
    price,
    quantity: 1,
    article: props[ID_ARTICLE_ATTRIBUTE]?.values?.[0]?.value,
    width: props[ID_WIDTH_ATTRIBUTE]?.values?.[0],
    depth: props[ID_DEPTH_ATTRIBUTE]?.values?.[0],
    height: props[ID_HEIGHT_ATTRIBUTE]?.values?.[0],
    images,
    selected: false,
    url: category && translitName ? `${category}${translitName}` : translitName || '',
    category,
    subCategory
  });

  const inStock = remainder !== undefined && +remainder !== 0;
  const cartButtonLabel = !inStock ? 'Нет в наличии' : productInCart ? 'Перейти в корзину' : 'Добавить в корзину';

  return (
    <Button
      disabled={!inStock}
      fullWidth
      size={viewPort === 'mobile' ? 'm' : 'l'}
      aria-label={cartButtonLabel}
      onClick={handleClickAddToCart}
      variant={productInCart ? 'tertiary' : 'accent'}
    >
      {cartButtonLabel}
    </Button>
  );
};
